import { WithdrawalActionType } from './actions'
import * as AT from './actionTypes'
import { WithdrawalResponse } from './types'

export type WithdrawState = {
  isSubmitting: boolean
  response?: WithdrawalResponse
}

const INITIAL_STATE: WithdrawState = {
  isSubmitting: false
}

const withdrawReducer = (state?: WithdrawState, action?: WithdrawalActionType) => {
  if (!state) return INITIAL_STATE
  if (!action) return state

  switch (action.type) {
    case AT.SUBMIT:
      return { ...state, isSubmitting: true }
    case AT.SUBMIT_SUCCESS:
      return { ...state, isSubmitting: false, response: action.payload }
    case AT.SUBMIT_ERROR:
      return { ...state, isSubmitting: false }
    case AT.RESET:
      return INITIAL_STATE
    default:
      return state
  }
  return state
}

export default withdrawReducer
